var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeeMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6577_28409)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#F2F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3884 7.48594L8.18902 4.20769C8.05842 4.07467 7.88175 4 7.6976 4C7.51345 4 7.33678 4.07467 7.20618 4.20769C7.14085 4.27408 7.089 4.35308 7.05361 4.44011C7.01822 4.52715 7 4.6205 7 4.71478C7 4.80907 7.01822 4.90242 7.05361 4.98945C7.089 5.07649 7.14085 5.15548 7.20618 5.22188L10.4126 8.49299C10.4779 8.55938 10.5298 8.63838 10.5652 8.72541C10.6005 8.81244 10.6188 8.9058 10.6188 9.00008C10.6188 9.09437 10.6005 9.18772 10.5652 9.27475C10.5298 9.36179 10.4779 9.44078 10.4126 9.50718L7.20618 12.7783C7.07493 12.9118 7.00082 13.0933 7.00017 13.2829C6.99952 13.4724 7.07237 13.6544 7.2027 13.7889C7.33303 13.9234 7.51016 13.9993 7.69514 14C7.88011 14.0007 8.05776 13.926 8.18902 13.7925L11.3884 10.5142C11.78 10.1125 12 9.56789 12 9.00008C12 8.43228 11.78 7.88769 11.3884 7.48594Z",
    fill: "#4B5262"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6577_28409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeMore);
export default __webpack_public_path__ + "static/media/see-more.d8d2dd5a4f423ec716b26a4aedad139e.svg";
export { ForwardRef as ReactComponent };